import { defineComponent as _defineComponent } from 'vue'
import { useMenu } from '@/hooks/useMenu';
import { E_RouterNames } from '@/router/types';
import { IMenuItem, hasChildren } from '@/view_helper/mainMenu';
import _ from 'lodash'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopMenuItem',
  props: {
    menu: null
  },
  emits: ["clickMenuItem"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'clickMenuItem', menu: IMenuItem)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    menu: IMenuItem
}






const {
    hasSubActive,
} = useMenu()

function onClickMenuItem(menu: IMenuItem) {
    emits('clickMenuItem', menu)
}


return { __sfc: true,props, emits, hasSubActive, onClickMenuItem, E_RouterNames, hasChildren }
}

})